import React from 'react';
import PropTypes from 'prop-types';
import Text from 'components/shared/Text';
import ButtonText from 'components/shared/ButtonText';
import styles from './styles.module.scss';

function TradeItem({ isUp, muted, children, ...props }) {
  const Component = props.onClick ? ButtonText : Text;
  return (
    <Component
      {...props}
      weight="regular"
      monospaced
      styles={[
        styles.tradeItem,
        {
          [styles.muted]: muted === true,
          [styles.tradeItemUp]: isUp === true,
          [styles.tradeItemDown]: isUp === false
        },
        ...props.styles
      ]}>
      {children}
    </Component>
  );
}

TradeItem.propTypes = {
  isUp: PropTypes.bool,
  muted: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.any.isRequired,
  styles: PropTypes.array
};

TradeItem.defaultProps = {
  isUp: null,
  muted: false,
  onClick: undefined,
  styles: []
};

export default TradeItem;
